import { useNavigate, useParams } from "react-router-dom";
import { IconButton } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useConfirm } from "material-ui-confirm";
import { styled } from "@mui/material/styles";

import { PaneListButton, PaneListItemHoverActions } from "./PaneListButton";
import { ResidentialZone, Scenario } from "src/types";
import { useResidentialZoneDeleteMutation } from "src/hooks/residential-zones";
import { IsEnabled } from "./permissions";

interface Props {
  scenario: Scenario;
  residentialZone: ResidentialZone;
}

export function ResidentialZoneListItem(props: Props) {
  const { scenario, residentialZone } = props;

  const { caseId = "", scenarioId = "", residentialZoneId = ""} = useParams<{
    caseId: string;
    scenarioId: string;
    residentialZoneId?: string;
  }>();
  const navigate = useNavigate();
  const confirm = useConfirm();

  const { t } = useTranslation();
  const deleteMutation = useResidentialZoneDeleteMutation(scenarioId, residentialZone.id);

  /**
   * Functions
   */
  function handleDelete(zone: ResidentialZone) {
    confirm({
      title: t("label.areYouSure"),
      description: t("confirm.deleteResidentialZone"),
      confirmationButtonProps: { autoFocus: true },
    }).then(() => {
      deleteMutation.mutate();
      // if the deleted item is being viewed, return to list of items
      if (residentialZoneId === zone.id.toString()) {
        navigate(`/cases/${caseId}/scenarios/${scenarioId}/residential-zones`);
      }
    });
  }

  return render();

  function render() {
    if (!scenario) return null;

    return (
      <Styles>
        <PaneListButton
          to={`/cases/${caseId}/scenarios/${scenarioId}/residential-zones/${residentialZone.id}`}
          className="list-item"
        >
          <div className="name">{residentialZone.name}</div>

          <PaneListItemHoverActions>
            <IsEnabled permission={scenario.permissions.updateResidential}>
              <IconButton
                onMouseDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  handleDelete(residentialZone);
                }}
                size="large"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </IsEnabled>
          </PaneListItemHoverActions>
        </PaneListButton>
      </Styles>
    );
  }
}

const Styles = styled("div")`
  .list-item {
    justify-content: space-between;
  }
`;
